<template>
  <div class="calendario">
    <b-input-group>
      <cleave
        v-model="fechaAuxiliar"
        :options="{ date: true, delimiter: '-', datePattern: ['Y', 'm', 'd'] }"
        :raw="false"
        class="form-control"
        placeholder="YYYY-MM-DD"
        :disabled="disabled"
      />
      <b-input-group-append>
        <b-form-datepicker
          v-model="fechaAuxiliar"
          :button-variant="color"
          :nav-button-variant="color"
          :selected-variant="color"
          :disabled="disabled"
          hide-header
          button-only
          right
          aria-controls="example-input"
          @context=" $emit('fechacalendario', onContext($event))"
        />
      </b-input-group-append>
    </b-input-group>
  </div>
</template>
<script>

import { ref, watch } from '@vue/composition-api'
import {
  BInputGroup,
  BInputGroupAppend,
  BFormDatepicker,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'

export default {
  components: {
    BInputGroup,
    BInputGroupAppend,
    BFormDatepicker,
    Cleave,
  },
  props: {
    color: {
      type: String,
      default: 'primary',
    },
    fecha: {
      type: Number,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const fechaAuxiliar = ref(null)

    const onContext = ctx => (ctx.selectedYMD ? Math.floor(new Date(`${ctx.selectedYMD}T00:00:00`).getTime() / 1000) : null)
    const formatoDate = ts => {
      if (!ts) return null

      const d = new Date(ts * 1000)
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')

      return `${y}-${m}-${day}`
    }

    watch(
      () => props.fecha,
      tt => {
        fechaAuxiliar.value = formatoDate(tt)
      },
      { immediate: true }, // ejecuta el watch al montar
    )
    return {
      fechaAuxiliar,
      onContext,
    }
  },

}
</script>

<style >
.calendario .input-group-append .btn {
    padding: .6em !important;
}
.calendario .btn-primary {
      background-color: #8fc3aa !important;
      border-color:#8fc3aa !important;
}
.calendario .btn-warning {
      background-color: #ffc58e !important;
      border-color:#ffc58e !important;
}

</style>
